export const DEVICE_TYPE = {
	DEFAULT: "",
	TABLET: "Tablet",
	MOBILE: "Mobile"
};

// Get resource by deciveType. Resources key in Sharepoint must have suffix of DEVICE_TYPE.
export const getResourceByDeviceType = (
	resources,
	resourceKey,
	deviceType = DEVICE_TYPE.DEFAULT
) => {
	const resourceToReturn = resources[resourceKey + deviceType];

	return resourceToReturn || resources[resourceKey];
};

// Get resources by deviceType. Resources key in Sharepoint must have suffix of DEVICE_TYPE.
// Returns object with the base resourceKeys (without "Tablet", "Mobile", etc)
export const getResourcesByDeviceType = (
	resources,
	resourceKeys,
	deviceType = DEVICE_TYPE.DEFAULT
) => {
	const resourcesToReturn = {};

	resourceKeys.forEach((key) => {
		resourcesToReturn[key] = getResourceByDeviceType(resources, key, deviceType);
	});

	return resourcesToReturn;
};
